import { isAfter } from 'date-fns'
import { dateAsYyyyMmDd } from 'util/date/formatDate'
import { afterEqualTo, composeRules, ErrorObject, maxLength, minLength, range, required } from 'util/validation'
import {
  campoFracionadoComBarraMaxUmAntes,
  campoFracionadoComVirgulaMaxDoisAntes,
} from 'util/validation/rules/valoresFracionados'

import { MedicamentoFormModel, TipoMotivoPrescricaoEnum } from '../model-prescricao'
import { calculateDataFimTratamento, duracaoFrequencia, isCampoInvalido } from './utils-prescricao'

export const validateDataInicioPrescricao = (dataInicio: string, dataAtendimento: Date) => {
  const dataInicioTratamento = new Date(dataInicio)

  if (dataInicioTratamento < dataAtendimento) {
    return afterEqualTo(dataInicio, dateAsYyyyMmDd(dataAtendimento), 'data do atendimento')
  }
}

export const validateFieldFracionado = (value: string) => {
  if (value?.includes('/')) {
    return campoFracionadoComBarraMaxUmAntes(value)
  } else if (value?.includes(',')) {
    return campoFracionadoComVirgulaMaxDoisAntes(value)
  }
}

export const validateDuracaoDentroDosLimitesPrescricao = (
  firstValue: number,
  firstValueKey: string,
  isIntervalo: boolean,
  values: MedicamentoFormModel,
  errors: ErrorObject<MedicamentoFormModel>
) => {
  const dataInicioTratamento = values.dataInicioTratamento
  const unidadeMedidaTempoFrequenciaTurno = values.unidadeMedidaTempoFrequenciaTurno
  const duracao = values.duracao
  const escalaDuracao = values.escalaDuracao

  const isAfterDuration = isAfter(
    calculateDataFimTratamento(firstValue, dataInicioTratamento, unidadeMedidaTempoFrequenciaTurno),
    calculateDataFimTratamento(duracao, dataInicioTratamento, escalaDuracao)
  )

  if (isAfterDuration && !errors.duracao) {
    if (firstValue && duracao) {
      errors[firstValueKey] = isCampoInvalido(isAfterDuration)(firstValue)
      errors.duracao = isCampoInvalido(isAfterDuration)(duracao)
      errors.frequenciaDuracao = duracaoFrequencia(
        firstValue,
        dataInicioTratamento,
        unidadeMedidaTempoFrequenciaTurno,
        escalaDuracao
      )(duracao)
    }
  } else {
    errors[firstValueKey] = composeRules([required, range(1, 99)])(firstValue)
    !isIntervalo && (errors.unidadeMedidaTempoFrequenciaTurno = required(unidadeMedidaTempoFrequenciaTurno))
  }
}

export const validateRegistroManualOuCombo = (
  values: MedicamentoFormModel,
  errors: ErrorObject<MedicamentoFormModel>
) => {
  if (values.registroManual) {
    errors.principioAtivoText = composeRules([required, maxLength(200)])(values.principioAtivoText)
    errors.formaFarmaceutica = required(values.formaFarmaceutica)
    errors.tipoReceita = required(values.tipoReceita)
    errors.unidadeFornecimento = composeRules([required, minLength(2), maxLength(100)])(values.unidadeFornecimento)
  } else if (!values.principioAtivoCombo) {
    errors.principioAtivoCombo = required(values.principioAtivoCombo)
  }
}

export const validateMotivoPrescricao = (values: MedicamentoFormModel, errors: ErrorObject<MedicamentoFormModel>) => {
  errors.tipoMotivoPrescricao = required(values.tipoMotivoPrescricao)
  if (values.tipoMotivoPrescricao === TipoMotivoPrescricaoEnum.CID10) {
    errors.cidMotivoPrescricao = required(values.cidMotivoPrescricao)
  } else if (values.tipoMotivoPrescricao === TipoMotivoPrescricaoEnum.CIAP2) {
    errors.ciapMotivoPrescricao = required(values.ciapMotivoPrescricao)
  }
}
